module.exports = __webpack_public_path__ + "static/googleplay-deu-light-d5f198d58d5ea93d9620ef5a8b907990.svg";